import { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

type SearhParamsReturnType = [URLSearchParams, (searchParams: URLSearchParams) => void];

export const useSearchParamsV6 = (): SearhParamsReturnType => {
  const { search } = useLocation();
  const history = useHistory();

  const searchParams = useMemo(() => new URLSearchParams(search) as URLSearchParams, [search]);

  const setSearchParams = (searchParams: URLSearchParams) => {
    history.replace({ search: searchParams.toString() });
  };

  return [searchParams, setSearchParams];
};
